import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { LinkFavicon } from '#pplx/frontend/components/links/LinkFavicon.js';
import { memo } from 'react';
export const TabCheckboxMenuItem = memo(function TabCheckboxMenuItem({ id, title, url, faviconUrl, checked, onCheckedChange }) {
    return (_jsx(DropdownMenu.CheckboxItem, { leadingAccessory: _jsx(LinkFavicon, { domain: url, src: faviconUrl, size: 16, hideBorder: true }), checked: checked, onCheckedChange: onCheckedChange, textValue: title, children: _jsx("span", { className: "block min-w-0 truncate", children: title }) }, id));
});
TabCheckboxMenuItem.displayName = 'TabCheckboxMenuItem';
//# sourceMappingURL=TabMenuItem.js.map